import React, { useState, useEffect } from "react";
import Style from "../../homework.module.scss";
import QuestionItem from "pages/homework/component/questionItem";
import Widget from "pages/homework/component/widget";
import { getExamTypeString, toNumber } from "pages/homework/utils/filter";
import { Button, Affix, Anchor } from "antd";
import _ from "underscore";
import { IGroupQuestion, IQuestion } from "pages/homework";
import CourseInfo from "../courseInfo";
import ExamInfo from "../examInfo";
import ExamAnchor from "../examAnchor";

const { Link } = Anchor;

interface CourseInfo {
    courseName: string;
    week: string;
    section: string;
    continunity: string;
    courseNo: string;
    courseSeq: string;
    weekTime: string;
    date: string;
}

interface HomeworkInfo {
    score: string;
    count: number;
    stuScore: string;
}

interface HomeworkMainPCProps {
    homeworkState: string;
    submitPaper: () => void;
    saveTopic: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => void;
    examList: IGroupQuestion[];
    courseInfo: CourseInfo;
    homeworkInfo: HomeworkInfo;
}

const HomeworkMainPC: React.FC<HomeworkMainPCProps> = ({
    homeworkState,
    courseInfo,
    homeworkInfo,
    saveTopic,
    submitPaper,
    examList
}) => {
    const [answeredTopics, setAnsweredTopics] = useState<number[]>([]);

    useEffect(() => {
        const list = _.reduce(
            examList,
            (memo: IQuestion[], item: IGroupQuestion) => [
                ...memo,
                ...item.list
            ],
            []
        );

        const array: number[] = [];
        list.forEach(topic => {
            if (topic.topics && topic.topics.length > 0) {
                topic.topics.forEach(topic => {
                    isAnswered(topic) && array.push(topic.topicId);
                });
            } else {
                isAnswered(topic) && array.push(topic.topicId);
            }
        });

        setAnsweredTopics(array);
    }, [examList]);

    const isEditorAnswer = (value: string | undefined) => {
        if (value === undefined) return false;
        return value !== "" && value !== "<p></p>";
    };

    const isAnswered = (item: IQuestion): boolean => {
        if (answeredTopics.includes(item.topicId)) return true;
        if (item.topicType === "4")
            return isEditorAnswer(item.answers[0].stuAnswer || "");
        if (item.topicType === "5")
            return _.some(item.answers, item =>
                isEditorAnswer(item.stuAnswer || "")
            );
        if (
            item.topics &&
            (item.topicType === "6" ||
                item.topicType === "7" ||
                item.topicType === "8")
        ) {
            return _.every(item.topics, topic => isAnswered(topic));
        }
        return _.some(item.answers, item => item.isChoose === "1");
    };

    const isTopicAnswered = (item: IQuestion) => {
        if (item.topics && item.topics.length > 0) {
            return _.every(item.topics || [], topic =>
                answeredTopics.includes(topic.topicId)
            );
        } else {
            return answeredTopics.includes(item.topicId);
        }
    };

    const handleSaveTopic = (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => {
        let isAnswered = topicType === "1" || topicType === "3";

        if (typeof answerId === "object") {
            isAnswered = answerId.length !== 0;
        }

        if (topicType === "4") {
            isAnswered = isEditorAnswer(value);
        }

        if (topicType === "5") {
            isAnswered = isEditorAnswer(value);
        }

        if (!answeredTopics.includes(topicId) && isAnswered) {
            setAnsweredTopics([...answeredTopics, topicId]);
        }

        if (!isAnswered) {
            setAnsweredTopics(_.without(answeredTopics, topicId));
        }
        saveTopic(topicId, topicType, answerId, value, userAnswers);
    };

    return (
        <div className={Style.main}>
            <Affix className={Style.leftWidget}>
                <div>
                    <Widget title="作业信息">
                        <div className={Style.body}>
                            <CourseInfo
                                courseName={courseInfo?.courseName}
                                weekTime={courseInfo?.weekTime}
                                section={courseInfo?.section}
                                continunity={courseInfo?.continunity}
                                date={courseInfo?.date}
                                score={homeworkInfo?.score}
                                quantity={homeworkInfo?.count}
                                bg={homeworkState === "2"}
                            />

                            {homeworkState === "2" && (
                                <ExamInfo
                                    score={homeworkInfo?.stuScore}
                                    list={examList}
                                />
                            )}
                            {homeworkState === "1" && (
                                <ExamAnchor list={examList} />
                            )}
                        </div>
                    </Widget>
                </div>
            </Affix>

            <div className={Style.rightWidget}>
                {examList.map((exam, index) => (
                    <Widget
                        key={index}
                        title={`${getExamTypeString(exam.topicType)}题`}
                        id={exam.topicType}>
                        {exam.list.map((topic, index) => (
                            <div
                                id={topic.topicId.toString()}
                                key={topic.topicId}>
                                <QuestionItem
                                    item={topic}
                                    score={topic.score}
                                    key={index}
                                    topicId={topic.topicId}
                                    topicType={topic.topicType}
                                    questionIndex={index + 1}
                                    trunk={topic.trunk}
                                    answers={topic.answers}
                                    homeworkState={toNumber(homeworkState)}
                                    onQuestionChange={handleSaveTopic}
                                    contentText={topic.contentText}
                                    comment={topic.comment}
                                    topics={topic.topics}
                                />
                            </div>
                        ))}
                    </Widget>
                ))}

                {homeworkState === "1" && (
                    <div className={Style.submit}>
                        <Button
                            onClick={submitPaper}
                            style={{ width: 120 }}
                            size={"large"}
                            type="primary"
                            icon="check-circle">
                            提交
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HomeworkMainPC;
